$(document).ready(function () {
  try {
    $('.navigation .menu .menu-item-has-children').each(function () {
      let $this = $(this);
      let $link = $this.children('a').eq(0);
      if ($link.text() === 'col') {
        $this.closest('.sub-menu').addClass('megamenu');
        $link.addClass('hide');
      }
    });
  } catch (e) {
    Rollbar.error('dropdown js', e);
  }
});
